<template>
  <layout>
    <template v-slot:header>
      <AppHead title="Edit MTD"/>
      <div class="admin-header-container">
        <h2>
          Edit Mobile Tool Distributor {{ form.first_name }} {{ form.last_name }} ({{ user.status_desc }})
        </h2>
        <jet-button :disabled="formApprove.processing" @click="approve()" class="ml-0 ml-lg-3 my-2 my-lg-0" icon="fas fa-thumbs-up" v-if="user.pending">
          Approve
        </jet-button>
      </div>
      <BreadCrumbs activeItem="Edit MTD" :crumbs="{ home: 'Dashboard', mtd: 'MTDs'}"/>
      <flash-messages/>
    </template>

    <template v-slot:default>
      <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore">
        This user has been deleted.
      </trashed-message>

      <form @submit.prevent="update" class="mt-3">
        <card title="MTD Info" headerStyle="primary">
          <div class="row">
            <div class="form-group col-sm-6">
              <jet-label for="company_name" value="Company name"/>
              <jet-input id="company_name" type="text" class="form-control" v-model="form.company_name"/>
              <jet-input-error :message="form.errors.company_name" class="mt-2"/>
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="first_name" value="First name"/>
              <jet-input id="first_name" type="text" class="form-control" v-model="form.first_name"/>
              <jet-input-error :message="form.errors.first_name" class="mt-2"/>
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="last_name" value="Last name"/>
              <jet-input id="last_name" type="text" class="form-control" v-model="form.last_name"/>
              <jet-input-error :message="form.errors.last_name" class="mt-2"/>
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="email" value="Email"/>
              <jet-input id="email" type="text" class="form-control" v-model="form.email"/>
              <jet-input-error :message="form.errors.email" class="mt-2"/>
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="phone" value="Phone"/>
              <jet-input id="phone" type="text" class="form-control" v-model="form.phone_number"/>
              <jet-input-error :message="form.errors.phone_number" class="mt-2"/>
              <div class="form-check mt-2">
                <jet-checkbox id="allow_sms"  class="form-check"  v-model:checked="form.allow_sms" />
                <jet-label for="allow_sms" value="Allow SMS to this number" />
              </div>
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="mtd_service_area" value="Service Area"/>
              <jet-input id="mtd_service_area" type="text" class="form-control" v-model="form.mtd_service_area"/>
              <jet-input-error :message="form.errors.mtd_service_area" class="mt-2"/>
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="mtd_info_dob" value="DOB" />
              <Calendar v-model="form.mtd_info_dob" class="w-100" id="mtd_info_dob" :showIcon="true" :selectOtherMonths="true"/>
              <jet-input-error :message="form.errors.mtd_info_dob" class="mt-2" />
              <p>Click year in calendar to first go back to year</p>
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="mtd_info_ssn_last4" value="SSN Last 4" />
              <jet-input id="mtd_info_ssn_last4"  type="text" class="form-control" v-model="form.mtd_info_ssn_last4" />
              <jet-input-error :message="form.errors.last_name" class="mt-2" />
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="mtd_info_ein" value="EIN (tax ID)" />
              <jet-input id="mtd_info_ein"  type="text" class="form-control" v-model="form.mtd_info_ein" />
              <jet-input-error :message="form.errors.mtd_info_ein" class="mt-2" />
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="mtd_assigned_rsm_id" value="Assigned RSM" />
              <select v-model="form.mtd_assigned_rsm_id" class="form-control">
                <option v-for="rsm in rsms" :key="rsm.id" :value="rsm.id">
                  {{ rsm.first_name }} {{ rsm.last_name }}
                </option>
              </select>
              <jet-input-error :message="form.errors.manufacturer" class="mt-2" />
            </div>
              <div class="form-group col-6">
                <jet-label for="mtd_status" value="Status" />
                <select v-model="form.mtd_status" class="form-control">
                  <option :key="1" :value="1">
                    Pending
                  </option>
                  <option :key="2" :value="2">
                    Assigned
                  </option>
                  <option :key="3" :value="3">
                    Approved
                  </option>
                  <option :key="4" :value="4">
                    Active
                  </option>
                  <option :key="5" :value="5">
                    Inactive
                  </option>
                </select>
              </div>
              <div class="form-group col-6">
                <div class="form-check">
                  <input type="checkbox" id="mtd_send_weekly_summary" class="form-check-input" v-model="form.mtd_send_weekly_summary" />
                  <jet-label for="mtd_send_weekly_summary" value="Send Weekly Summary Email" />
                  <jet-input-error :message="form.errors.mtd_send_weekly_summary" class="mt-2" />
                </div>

                <div class="form-check">
                  <input type="checkbox" id="mtd_use_customer_direct" class="form-check-input" v-model="form.mtd_use_customer_direct" />
                  <jet-label for="mtd_use_customer_direct" value="Allow MTD to use Customer Direct" />
                  <jet-input-error :message="form.errors.mtd_use_customer_direct" class="mt-2" />
                </div>

                <div class="form-check">
                  <input type="checkbox" id="mtd_instant_payment_only" class="form-check-input" v-model="form.mtd_instant_payment_only" />
                  <jet-label for="mtd_instant_payment_only" value="Allow only instant payment" />
                  <jet-input-error :message="form.errors.mtd_instant_payment_only" class="mt-2" />
                </div>
                
                
              </div>
          </div>
        </card>

        <div class="row mt-3">
          <div class="col-12 col-lg-6">
            <card title="Billing Address" headerStyle="primary">
              <div class="row">
                <div class="form-group col-sm-6">
                  <jet-label for="address1" value="Address"/>
                  <GMapAutocomplete
                    id="address1"
                    class="form-control"
                    placeholder="Start typing billing address.."
                    @place_changed="getBillingAddressData"
                    @change="changeBillingAddressData"
                  />
                  <jet-input-error :message="form.errors.address1" class="mt-2"/>
                </div>
                <div class="form-group col-sm-6">
                  <jet-label for="address2" value="Unit / Suite"/>
                  <jet-input id="address2" type="text" class="form-control" v-model="form.address2"/>
                  <jet-input-error :message="form.errors.address2" class="mt-2"/>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-3">
                  <jet-label for="city" value="City"/>
                  <jet-input id="city" type="text" class="form-control" v-model="form.city"/>
                  <jet-input-error :message="form.errors.city" class="mt-2"/>
                </div>

                <div class="form-group col-sm-3">
                  <jet-label for="country" value="Country" />
                  <select v-model="form.country" class="form-control">
                    <option v-for="country in countries" :key="country.iso_code_2" :value="country.iso_code_2">
                      {{ country.iso_code_2 }} - {{ country.name }}
                    </option>
                  </select>
                  <jet-input-error :message="form.errors.country" class="mt-2" />
                </div>

                <div class="form-group col-sm-3">
                  <jet-label for="state" value="State"/>
                  <select v-model="form.state" id="state" class="form-control">
                    <option v-for="state in statesByCountry" :key="state.code" :value="state.code">
                      {{ state.code }} - {{ state.name }}
                    </option>
                  </select>
                  <jet-input-error :message="form.errors.state" class="mt-2"/>
                </div>

                <div class="form-group col-sm-3">
                  <jet-label for="postcode" value="Zip"/>
                  <jet-input id="postcode" type="text" class="form-control" v-model="form.postcode"/>
                  <jet-input-error :message="form.errors.postcode" class="mt-2"/>
                </div>
              </div>
            </card>
          </div>

          <div class="col-12 col-lg-6">
            <card title="Shipping Address" headerStyle="primary">
              <div class="row">
                <div class="form-group col-sm-6">
                  <jet-label for="ship_address1" value="Address"/>
                  <GMapAutocomplete
                    id="ship_address1"
                    ref="shippingAddress"
                    class="form-control"
                    placeholder="Start typing shipping address.."
                    @place_changed="getShippingAddressData"
                    @change="changeShippingAddressData"
                  />
                  <jet-input-error :message="form.errors.ship_address1" class="mt-2"/>
                </div>
                <div class="form-group col-sm-6">
                  <jet-label for="ship_address2" value="Unit / Suite"/>
                  <jet-input id="ship_address2" type="text" class="form-control" v-model="form.ship_address2"/>
                  <jet-input-error :message="form.errors.ship_address2" class="mt-2"/>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-3">
                  <jet-label for="ship_city" value="City"/>
                  <jet-input id="ship_city" type="text" class="form-control" v-model="form.ship_city"/>
                  <jet-input-error :message="form.errors.ship_city" class="mt-2"/>
                </div>
                <div class="form-group col-sm-3">
                  <jet-label for="ship_country" value="Country" />
                  <select v-model="form.ship_country" class="form-control">
                    <option v-for="country in countries" :key="country.iso_code_2" :value="country.iso_code_2">
                      {{ country.iso_code_2 }} - {{ country.name }}
                    </option>
                  </select>
                  <jet-input-error :message="form.errors.ship_country" class="mt-2" />
                </div>
                <div class="form-group col-sm-3">
                  <jet-label for="ship_state" value="State"/>
                  <select v-model="form.ship_state" class="form-control">
                    <option v-for="state in shipStatesByCountry" :key="state.code" :value="state.code">
                      {{ state.code }} - {{ state.name }}
                    </option>
                  </select>
                  <jet-input-error :message="form.errors.ship_state" class="mt-2"/>
                </div>
                <div class="form-group col-sm-3">
                  <jet-label for="ship_postcode" value="Zip"/>
                  <jet-input id="ship_postcode" type="text" class="form-control" v-model="form.ship_postcode"/>
                  <jet-input-error :message="form.errors.ship_postcode" class="mt-2"/>
                </div>
              </div>
            </card>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <EditTags :tags="tags" :savedTags="user.tags" :userIds="[user.id]"></EditTags>
          </div>
          
          <div class="col-md-6 mt-3">
            <Card title="Super Admin Only" headerStyle="warning" v-if="isSuper">
              <div class="form-group col-sm-6">
                <jet-label for="mtd_wholesale_discount_percent" value="Product Pricing Discount Percent"/>
                <jet-input id="mtd_wholesale_discount_percent"
                           type="text"
                           class="form-control"
                           v-model="form.mtd_wholesale_discount_percent"/>
                <p>Enter as decimal (for 2% enter .02)</p>
                <jet-input-error :message="form.errors.mtd_wholesale_discount_percent" class="mt-2"/>
              </div>
              <div class="form-group col-sm-6">
                <input type="checkbox" id="mtd_ship_approved" class="form-check-input" v-model="form.mtd_ship_approved" />
                <jet-label for="mtd_ship_approved" value="Enable Ship Items without Approval" />
                <jet-input-error :message="form.errors.mtd_ship_approved" class="mt-2" />
              </div>
            </Card>
          </div>
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <jet-button class="px-5 ml-auto" btnStyle="success" icon="fas fa-user" :disable="form.processing" type="submit">Update User</jet-button>
        </div>
      </form>
    </template>
  </layout>
</template>

<script>
import AppHead from '@/Shared/AppHead'
import Card from '@/Shared/Card'
import Layout from '@/Shared/Admin/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import TrashedMessage from '@/Shared/TrashedMessage'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetActionMessage from '@/Jetstream/ActionMessage'
import BreadCrumbs from '@/Shared/BreadCrumbs'

import Calendar from 'primevue/calendar';
import EditTags from "@/Shared/EditTags";
import Helpers from '@/Helpers'

export default {
  metaInfo() {
    return {
      title: `${this.form.first_name} ${this.form.last_name}`,
    }
  },
  components: {
    EditTags,
    AppHead,
    FileInput,
    SelectInput,
    TextInput,
    TrashedMessage,
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetCheckbox,
    JetInputError,
    JetLabel,
    Layout,
    BreadCrumbs,
    Card,
    Calendar,
  },
  props: {
    user: Object,
    rsms: Array,
    states: Array,
    countries: Array,
    isSuper: Boolean,
    tags: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        phone_number: this.user.phone_number,
        allow_sms: this.user.allow_sms == 1,
        company_name: this.user.company_name,
        mtd_service_area: this.user.mtd_service_area,
        mtd_info_dob: this.user.mtd_info_dob,
        mtd_info_ssn_last4: this.user.mtd_info_ssn_last4,
        mtd_info_ein: this.user.mtd_info_ein,
        mtd_status: this.user.mtd_status,
        mtd_send_weekly_summary: this.user.mtd_send_weekly_summary == 1,
        address1: this.user.address_bill ? this.user.address_bill.address1 : null,
        address2: this.user.address_bill ? this.user.address_bill.address2 : null,
        city: this.user.address_bill ? this.user.address_bill.city : null,
        state: this.user.address_bill ? this.user.address_bill.state : null,
        country: this.user.address_bill ? this.user.address_bill.country : null,
        postcode: this.user.address_bill ? this.user.address_bill.postcode : null,
        ship_address1: this.user.address_ship ? this.user.address_ship.address1 : null,
        ship_address2: this.user.address_ship ? this.user.address_ship.address2 : null,
        ship_city: this.user.address_ship ? this.user.address_ship.city : null,
        ship_state: this.user.address_ship ? this.user.address_ship.state : null,
        ship_country: this.user.address_ship ? this.user.address_ship.country : null,
        ship_postcode: this.user.address_ship ? this.user.address_ship.postcode : null,
        mtd_assigned_rsm_id: this.user.address_ship ? this.user.mtd_assigned_rsm_id : null,
        mtd_wholesale_discount_percent: this.user.mtd_wholesale_discount_percent ? this.user.mtd_wholesale_discount_percent : null,
        mtd_ship_approved: this.user.mtd_ship_approved == 1,
        mtd_use_customer_direct: this.user.mtd_use_customer_direct == 1,
        mtd_instant_payment_only: this.user.mtd_instant_payment_only == 1,
      }),

      formApprove: this.$inertia.form({
        _method: 'put'
      })
    }
  },
  computed: {
    shipStatesByCountry() {
      if (!this.form.ship_country) {
        return this.states
      }
      return this.states.filter(s => s.country_code == this.form.ship_country)
    },
    statesByCountry() {
      if (!this.form.country) {
        return this.states
      }
      return this.states.filter(s => s.country_code == this.form.country)
    }
  },
  watch: {
    'form.state'(val) {
      const state = this.states.find(s => s.code == val)
      this.form.country = state?.country_code
    },
    'form.ship_state'(val) {
      const state = this.states.find(s => s.code == val)
      this.form.ship_country = state?.country_code
    },
  },
  mounted() {
    if (this.form.address1) document.getElementById('address1').value = this.form.address1
    if (this.form.ship_address1) document.getElementById('ship_address1').value = this.form.ship_address1
  },
  methods: {
    update() {
      this.form.address1 = document.getElementById('address1').value
      this.form.ship_address1 = document.getElementById('ship_address1').value
      this.form.post(this.route('mtd.update', this.user.id))
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(this.route('users.restore', this.user.id))
      }
    },
    changeBillingAddressData(e) {
      this.form.address1 = e.target.value
    },
    changeShippingAddressData(e) {
      this.form.ship_address1 = e.target.value
    },
    getBillingAddressData(info) {
      const city = Helpers.getAddressComponent('locality', info)
      const state = Helpers.getAddressComponent('administrative_area_level_1', info)
      const zipcode = Helpers.getAddressComponent('postal_code', info)

      const street_number = Helpers.getAddressComponent('street_number', info)
      const route = Helpers.getAddressComponent('route', info)
      let address1 = '';
      if (street_number.length && route.length) {
        address1 = street_number[0].long_name + ' ' + route[0].short_name;
      } else if (info.name) {
        address1 = info.address
      }
      this.form.address1 = address1
      document.getElementById('address1').value = address1
   
      if (city.length) this.form.city = city[0].long_name
      if (state.length) this.form.state = state[0].short_name
      if (zipcode.length) this.form.postcode = zipcode[0].long_name
    },
    getShippingAddressData(info) {
      const city = Helpers.getAddressComponent('locality', info)
      const state = Helpers.getAddressComponent('administrative_area_level_1', info)
      const zipcode = Helpers.getAddressComponent('postal_code', info)

      const street_number = Helpers.getAddressComponent('street_number', info)
      const route = Helpers.getAddressComponent('route', info)
      let address1 = '';
      if (street_number.length && route.length) {
        address1 = street_number[0].long_name + ' ' + route[0].short_name;
      } else if (info.name) {
        address1 = info.address
      }
      this.form.ship_address1 = address1
      document.getElementById('ship_address1').value = address1
      if (city.length) this.form.ship_city = city[0].long_name
      if (state.length) this.form.ship_state = state[0].short_name
      if (zipcode.length) this.form.ship_postcode = zipcode[0].long_name
    },
    approve() {
      this.formApprove.post(this.route('mtd.approve', this.user.id))
    }
  },
}
</script>
